import Vue from 'vue'
// Components
import './customs'
import VModal from 'vue-js-modal'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import VueSocialSharing from 'vue-social-sharing'
import './components/js-component'
import './components/validate/validate'
import Components from './components/app'

Vue.prototype.trans = window.trans
Vue.prototype.global = window.global
Vue.use(VModal, { dynamic: true })
Vue.use(VueGoogleAutocomplete)
Vue.use(VueSocialSharing)

Vue.use(Components)
window.app = new Vue({
  el: '#app',
  data() {
    return {
      window: {
        width: 0,
      },
      xl: 1200,
      lg: 992,
      md: 768,
      sm: 564,
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    },
    goToForm() {
      const element = document.getElementById('form');
      if (element) {
        element.scrollIntoView({ block: 'center' });
      }
    },
  },
})

export function selectByQuery(element) {
  return document.querySelector(element) || {}
}

export function selectGetElements(element) {
  return document.getElementsByClassName(element) || []
}



// WEBPACK FOOTER //
// ./src/js/main.js